<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.no" placeholder="business.label.no" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="no" title="business.label.no"/>
        <vxe-column field="name" title="business.label.name"/>
        <vxe-column field="alignment" title="business.label.alignment"/>
        <vxe-column field="displayMode" title="business.label.displayMode"/>
        <vxe-column field="type" title="business.label.fieldType"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="copy(row)"/>
            <vxe-button content="button.detail" icon="vxe-icon-association-form" status="primary" @click.stop="getDetail(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <field-editor ref="editor" @success="refresh"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import FieldEditor from '@/views/config/dictionary/FieldEditor.vue'
import { Field } from '@/api/dto/admin/Field'

export default {
  name: 'DictionaryTable',
  components: { FieldEditor },
  data() {
    return {
      loading: false,
      data: [],
      query: new Field(),
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('fieldFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new Field()
      this.refresh()
    },
    add() {
      this.$refs.editor.add()
    },
    edit(row) {
      this.$refs.editor.edit(row.id, false)
    },
    copy(row) {
      this.$refs.editor.edit(row.id, true)
    },
    getDetail(row) {
      this.$emit('getDetail', row)
    }
  }
}
</script>